import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { DisciplinaryActionListComponent } from './disciplinary-action/disciplinary-action-list.component'
import { GroupsComponent } from './groups/groups.component'
import { NotificationsComponent } from './notifications/notifications.component'
import { OrgChartComponent } from './org-chart/org-chart.component'
import { RetentionComponent } from './retention/retention.component'
import { SafetyComponent } from './safety/safety.component'
import { ScorecardComponent } from './scorecard/scorecard.component'

export const hrRoutes: Routes = [
    {
        path: 'hr',
        children: [
            RouteUtil.Make('safety', SafetyComponent, FeatureType.HrSafetyView),
            RouteUtil.Make('retention', RetentionComponent, FeatureType.HrRetentionView),
            RouteUtil.Make('scorecard', ScorecardComponent, [
                FeatureType.HrScorecardGoalsView,
                FeatureType.HrScorecardHiringView,
                FeatureType.HrScorecardAdminView,
            ]),
            RouteUtil.Make('org-chart', OrgChartComponent, FeatureType.HrAccountabilityChartView),
            RouteUtil.Make('notifications', NotificationsComponent, FeatureType.HrNotificationView),
            RouteUtil.Make('groups', GroupsComponent, FeatureType.HrGroupsView),
            RouteUtil.Make('disciplinary-action', DisciplinaryActionListComponent, FeatureType.HrDisciplinaryActionView),
        ],
    },
]
